export default {
    'ERROR_CHECK_TEAMSPACE_ALLOWED': {
        'USER-DOES-NOT-HAVE-ACCESS-TO-TEAMSPACE': {
            actionType: 'redirect',
            message: {
                fr: 'Vous ne pouvez pas accèder à cette équipe',
                en: 'You cannot access this team',
            },
            redirectPath: '/',
        },
    },
};
